import { render, staticRenderFns } from "./f-account-list.vue?vue&type=template&id=3bdd8c20&scoped=true"
import script from "./f-account-list.vue?vue&type=script&lang=js"
export * from "./f-account-list.vue?vue&type=script&lang=js"
import style0 from "./f-account-list.vue?vue&type=style&index=0&id=3bdd8c20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd8c20",
  null
  
)

export default component.exports